import { Divider, Stack, Typography } from "@mui/material";
import CalendarDayFillIcon from "src/components/ui/svgIcon/CalendarDayFillIcon";
import CircleClockFillIcon from "src/components/ui/svgIcon/CircleClockFillIcon";
import UserProfileFillIcon from "src/components/ui/svgIcon/UserProfileFillIcon";
import { FooterBox } from "./style";
import useDate from "../../services/footerDashboard/Timer";
import { useContext, useEffect } from "react";
import useUserCheck from "src/layouts/useUserCheck";
import { useNavigate } from "react-router-dom";
import { UserContext } from "src/contexts/UserContext";
import SketchIcon from "src/components/ui/svgIcon/SketchIcon";
import useGetActiveSubscription from "../../services/footerDashboard/useGetActiveSubscription";

const Footer = () => {
  const navigate = useNavigate();
  const { username, isLoggedin, subscription, setSubscription } = useContext(UserContext);
  const [dateRaw, time, date, refreshTime] = useDate();

  const { loginStatus } = useUserCheck();
  const { data } = useGetActiveSubscription("S.AVC.AVC.activeSubscription.Full");

  useEffect(() => {
    if (data) {
      const activePlan = {
        planId: +data?.activeSubscription?.plan?.id,
        planTitle: data?.activeSubscription?.plan?.title,
        planEndDate: data?.activeSubscription?.endDate,
        extensionDeadline: data?.activeSubscription?.extensionDeadline,
        remainingDays: data?.activeSubscription?.remainingDays,
      };
      setSubscription(activePlan);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    loginStatus();
    if (!isLoggedin) {
      navigate("/login");
    }
  }, [refreshTime]);

  function handleShowingPlan() {
    if (data) {
      if (subscription?.planTitle && subscription?.remainingDays) {
        if (subscription?.remainingDays > 0) {
          return (
            <Stack gap={1} flexDirection={"row"}>
              <Typography variant="body2">{subscription?.planTitle}</Typography>
              <Typography
                color={"grey.gm"}
                variant="body1"
                fontWeight={600}
              >{`(${subscription?.remainingDays} روز تا پایان)`}</Typography>
            </Stack>
          );
        } else if (subscription?.remainingDays <= 0) {
          return (
            <Typography variant="body2" color={"error.main"}>
              فاقد طرح کاربری فعال
            </Typography>
          );
        }
      } else {
        return (
          <Typography variant="body2" color={"error.main"}>
            فاقد طرح کاربری فعال
          </Typography>
        );
      }
    }
  }

  return (
    <FooterBox>
      <Stack
        flexDirection="row"
        justifyContent="space-around"
        alignItems="center"
        height={1}
        flexWrap="wrap"
        bgcolor="grey.gb"
        sx={{ borderRadius: 999 }}
      >
        <Stack flexDirection="row" alignItems="center">
          <UserProfileFillIcon fontSize="small" />
          <Divider
            sx={{ mx: 1, border: (theme) => `1px dashed ${theme.palette.grey[600]}` }}
            orientation="vertical"
            flexItem
          />
          <Typography variant="body2">{username}</Typography>
        </Stack>

        <Stack flexDirection="row" alignItems="center">
          <SketchIcon fontSize="small" />
          <Divider
            sx={{ mx: 1, border: (theme) => `1px dashed ${theme.palette.grey[600]}` }}
            orientation="vertical"
            flexItem
          />
          {handleShowingPlan()}
        </Stack>

        <Stack flexDirection="row" alignItems="center" width={"110px"}>
          <CircleClockFillIcon fontSize="small" />
          <Divider
            sx={{ mx: 1, border: (theme) => `1px dashed ${theme.palette.grey[600]}` }}
            orientation="vertical"
            flexItem
          />
          <Typography variant="body1">{time}</Typography>
        </Stack>
        <Stack flexDirection="row" alignItems="center">
          <CalendarDayFillIcon fontSize="small" />
          <Divider
            sx={{ mx: 1, border: (theme) => `1px dashed ${theme.palette.grey[600]}` }}
            orientation="vertical"
            flexItem
          />
          <Typography variant="body1">{date ?? "_"}</Typography>
        </Stack>
        <Stack flexDirection="row" alignItems="center">
          <CalendarDayFillIcon fontSize="small" />
          <Divider sx={{ mx: 1, border: "1px dashed grey" }} orientation="vertical" flexItem />
          <Typography variant="body2" fontFamily="Arial, sans-serif" fontWeight={550} fontSize={17}>
            {dateRaw[0] ?? "_"}
          </Typography>
        </Stack>
      </Stack>
    </FooterBox>
  );
};

export default Footer;
